import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { BaseService } from '@core/services/base.service';
import { ConfigService } from '@shared/utils/config.service';
import { Observable } from 'rxjs';

@Injectable()
export class CartaoService extends BaseService{
  baseUrl: string = "";
  mockUrl = "http://localhost:3000"

  constructor(private http: Http, private configService: ConfigService) {
    super();
    this.baseUrl = configService.getApiURI();
  }

  authorizedHeaders(): Headers {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return headers;
  }

  saveClienteCartao(params): Observable<any> {
    // salvarAlerta(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(
        `${this.baseUrl}/clienteCartao/saveClienteCartao?cnpj=${params.cnpj}&nomeLoja=${params.nomeLoja}&nomeContato=${params.nomeContato}&ddd1=${params.ddd1}&tel1=${params.tel1}&ddd2=${params.ddd2}&tel2=${params.tel2}&cdfzs=${params.cdfzs}`,
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);

  }

  getListCartaoCliente(params): Observable<any> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(this.baseUrl + `/clienteCartao/getListCartaoCliente?cdfzs=${params.cdfzs}`, { headers })
      .map(response => response.json())
      .catch(this.handleError);
  }
}